import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Flame, Menu, X } from "lucide-react";

const NAV = [
  { label: "Work", to: "/#work" },
  { label: "Studio", to: "/#studio" },
  { label: "Founders", to: "/#founders" },
  { label: "Contact", to: "/#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-2xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
          <Flame className="w-6 h-6 text-[#E8954A] transition-transform group-hover:scale-110" strokeWidth={2.2} />
          <span className="font-display font-extrabold tracking-tight text-lg uppercase">
            Iron Fire
            <span className="text-white/40 ml-1.5 font-medium">Productions</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-sm text-white/65 hover:text-white transition-colors tracking-wide"
            >
              {n.label}
            </a>
          ))}
          <a
            href="/#work"
            data-testid="nav-cta"
            className="text-sm font-semibold bg-white text-black px-5 py-2.5 rounded-sm hover:bg-[#E8954A] transition-all duration-300 hover:-translate-y-0.5"
          >
            View Projects
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-2xl border-b border-white/10 px-6 py-6 flex flex-col gap-5">
          {NAV.map((n) => (
            <a key={n.label} href={n.to} className="text-base text-white/80" data-testid={`mobile-nav-${n.label.toLowerCase()}`}>
              {n.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
